var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.auth && _vm.userType == 10)?_c('Admin'):(_vm.auth && _vm.userType == 30)?_c('App'):_vm._e(),(!_vm.auth)?_c('Auth'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }